import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowRight, Lock } from 'lucide-react';
import { authService } from '../services/authService';

const PasswordField = ({ label, value, onChange }) => {
  const [visible, setVisible] = useState(false);
  return (
    <label className="auth-field">
      <span>{label}</span>
      <div className="auth-password-wrap">
        <input type={visible ? 'text' : 'password'} value={value} onChange={onChange} />
        <button type="button" onClick={() => setVisible((current) => !current)}>
          {visible ? 'Hide' : 'Show'}
        </button>
      </div>
    </label>
  );
};

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const submitReset = async (event) => {
    event.preventDefault();
    setMessage('');
    if (!token) {
      setMessage('Reset token is missing. Request a new reset link.');
      return;
    }
    if (password.length < 6) {
      setMessage('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirmPassword) {
      setMessage('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      const result = await authService.resetPassword({ token, password });
      setMessage(result.message);
      window.setTimeout(() => navigate('/auth'), 900);
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="auth-page" aria-label="Reset MindVrik password">
      <div className="auth-shell">
        <div className="auth-copy">
          <div className="section-label">MindVrik Access</div>
          <h1>Set a new password.</h1>
          <p>
            Choose a secure password for your MindVrik account. The reset link
            can be used only once and expires shortly.
          </p>
        </div>

        <div className="auth-card">
          <div className="auth-tabs single">
            <button className="active" type="button">Reset Password</button>
          </div>
          {message && <div className="auth-message">{message}</div>}
          <form onSubmit={submitReset}>
            <PasswordField label="New Password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <PasswordField label="Confirm Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
            <button className="btn-primary auth-submit" type="submit" disabled={loading}>
              <Lock size={15} /> Update Password <ArrowRight size={15} />
            </button>
            <button type="button" className="auth-link" onClick={() => navigate('/auth')}>Back to login</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ResetPasswordPage;
